import { Loader2 } from "lucide-react";
import { Progress } from "@/components/ui/progress";

interface PDFExportLoaderProps {
  isVisible: boolean;
  currentStep: number;
  totalSteps: number;
  message: string;
}

export const PDFExportLoader = ({ 
  isVisible, 
  currentStep, 
  totalSteps, 
  message 
}: PDFExportLoaderProps) => {
  if (!isVisible) return null;
  
  const progress = (currentStep / totalSteps) * 100;
  
  return (
    <div className="fixed inset-0 bg-black/50 z-[100] flex items-center justify-center">
      <div className="bg-background rounded-lg p-8 max-w-md w-full mx-4 space-y-6 border shadow-lg">
        <div className="flex items-center gap-3">
          <Loader2 className="h-6 w-6 animate-spin text-primary" />
          <h3 className="text-lg font-semibold">Gerando Relatório PDF</h3>
        </div>
        
        <div className="space-y-2">
          <div className="flex justify-between text-sm text-muted-foreground">
            <span>{message}</span>
            <span>{currentStep}/{totalSteps}</span>
          </div>
          <Progress value={progress} className="h-2" />
        </div>
      </div>
    </div>
  );
};
